import { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SimpleReactValidator from 'simple-react-validator';

import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import { Marker, TileLayer, MapContainer } from 'react-leaflet';

import { nextFirstSection } from '../../../store/actions/order';
import { GetUser } from '../../../store/actions/kalapost';

const skater = new Icon({
   iconUrl: `./img/side.svg`,
   iconSize: [25, 25],
});
const TypeGoods = () => {
   const dispatch = useDispatch();
   const { section, cityName, originLng, originLat, serviceTypeId, deliveryTypeId, addressSender } =
      useSelector((state) => state.order);

   const [, forceUpdate] = useState();
   const [registerOrder, setRegisterOrder] = useState({
      states: [],
      state: '',
      city: cityName,
      Lat: '35.70290756225590',
      Lng: '51.34975814819340',
      serviceId: serviceTypeId,
      deliveryId: deliveryTypeId,
      address: addressSender,
      cities: [],
      packSizePackages: [],
      packSizePacking: [],
      origin: '',
   });

   const validator = useRef(
      new SimpleReactValidator({
         messages: {
            required: 'پر کردن این فیلد الزامی میباشد',
         },
         element: (message) => <div style={{ color: 'red', fontSize: '1.3rem' }}>{message}</div>,
      })
   );

   useEffect(() => {
      const handleUser = async () => {
         const res = await GetUser('addService', '');
         res.status &&
            setRegisterOrder({
               ...registerOrder,
               states: res.data.states,
               state: res.data.user.stateName,
               city: res.data.user.cityName,
               address: res.data.user.address,
               packSizePackages: res.data.packSizePackages,
               packSizePacking: res.data.packSizePacking,
               origin: res.data.user.cityId,
               Lat: res.data?.cityInfo?.originLat ?? '35.70290756225590',
               Lng: res.data?.cityInfo?.originLng ?? '51.34975814819340',
            });
      };
      handleUser();
   }, []);

   const handleChange = (e) => {
      setRegisterOrder({
         ...registerOrder,
         [e.target.name]: e.target.value,
      });
      validator.current.showMessageFor(e.target.name);
   };
   const handleChangeMap = (e) => {
      setRegisterOrder({
         ...registerOrder,
         Lat: Number(e.latlng['lat']),
         Lng: Number(e.latlng['lng']),
      });
   };
   const handleNext = () => {
      if (validator.current.allValid()) {
         dispatch(
            nextFirstSection(
               registerOrder.deliveryId,
               registerOrder.serviceId,
               registerOrder.cities,
               registerOrder.packSizePackages,
               registerOrder.packSizePacking,
               registerOrder.states,
               registerOrder.origin
            )
         );
      } else {
         validator.current.showMessages();
         forceUpdate(1);
      }
   };

   return (
      <div
         className={section === 1 ? `progresstabs__content active-nav` : `progresstabs__content`}
         style={{ minHeight: 'unset' }}
      >
         <h1 className='progresstabs__content-title'>انتخاب و تایید مبدا</h1>
         <div className='progresstabs__content-source'>
            <div className='progresstabs__content-source-info'>
               <div className='progresstabs__content-source-city'>
                  <label className='progresstabs__content-source-lable' htmlFor='city-select'>
                     استان
                  </label>
                  <input
                     className='progresstabs__content-source-selector'
                     name='city'
                     type='text'
                     value={registerOrder.state}
                     readOnly
                  />
               </div>
               <div className='progresstabs__content-source-city'>
                  <label className='progresstabs__content-source-lable' htmlFor='city-select'>
                     شهر
                  </label>
                  <input
                     className='progresstabs__content-source-selector'
                     name='city'
                     type='text'
                     value={registerOrder.city}
                     readOnly
                  />
               </div>
               <div className='progresstabs__content-source-address'>
                  <label className='progresstabs__content-source-lable' htmlFor='address'>
                     آدرس
                  </label>
                  <textarea
                     rows='10'
                     placeholder='آدرس خود را اینجا وارد کنید'
                     className='progresstabs__content-source-textarea'
                     value={registerOrder.address || ''}
                     readOnly
                  />
               </div>
            </div>

            <div className='progresstabs__content-source-map' style={{ background: '#ddd' }}>
               {registerOrder.Lat && registerOrder.Lng ? (
                  <MapContainer
                     center={[registerOrder.Lat, registerOrder.Lng]}
                     zoom={13}
                     scrollWheelZoom={false}
                     style={{ width: '100%', height: '100%', flex: '0 0 auto' }}
                  >
                     <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                     />
                     <Marker
                        position={[registerOrder.Lng, registerOrder.Lat]}
                        icon={skater}
                     ></Marker>
                  </MapContainer>
               ) : (
                  <div
                     style={{ width: '100%', height: '100%', flex: '0 0 auto', background: '#ddd' }}
                  ></div>
               )}
            </div>
         </div>
         <h1 className='progresstabs__content-title' style={{ paddingTop: '2rem' }}>
            انتخاب نوع ارسال و تحویل
         </h1>
         <div className='progresstabs__content-source'>
            <div className='progresstabs__content-source-post'>
               <label className='progresstabs__content-source-lable' htmlFor='serviceId'>
                  نوع ارسال
                  <select
                     id='serviceId'
                     className='progresstabs__content-source-selector progresstabs__content-source-selector--post'
                     name='serviceId'
                     value={registerOrder.serviceId}
                     onChange={handleChange}
                  >
                     <option hidden>انتخاب کنید...</option>
                     {/* <option value="درون شهری">درون شهری</option> */}
                     <option value='1'>کالاپست</option>
                     {/* <option value="باربری">باربری</option> */}
                     {/* <option value="اداره پست">اداره پست</option> */}
                  </select>
                  {validator.current.message('serviceId', registerOrder.serviceId, 'required')}
               </label>
            </div>
            <div className='progresstabs__content-source-delivery'>
               <label className='progresstabs__content-source-lable' htmlFor='deliveryId'>
                  نوع تحویل
                  <select
                     id='deliveryId'
                     className='progresstabs__content-source-selector progresstabs__content-source-selector--delivery'
                     name='deliveryId'
                     value={registerOrder.deliveryId}
                     onChange={handleChange}
                  >
                     <option hidden>انتخاب کنید...</option>
                     <option value='1'>درب به درب</option>
                     <option value='2'>باجه کالاپست شهر مقصد</option>
                  </select>
                  {validator.current.message('deliveryId', registerOrder.deliveryId, 'required')}
               </label>
            </div>
         </div>
         <div className='progresstabs__content-buttons'>
            <button className={`btn btn--secondary next-btn `} onClick={handleNext}>
               تایید و ادامه
            </button>
         </div>
      </div>
   );
};

export default TypeGoods;
